<msf-select
  [model]="model()"
  (modelChange)="onModelChange($event)"
  [options]="options()"
  optionLabel="label"
  [optionValue]="optionValue()"
  optionSubtitle="key"
  [showSelectedSubtitle]="showSelectedSubtitle()"
  translateBy="locale"
  [showClear]="showClear()"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [width]="width()"
></msf-select>
